<ul class="layout-menu">
  @for (item of menuItems(); track $index; let i = $index) {
    <li app-menuitem [item]="item" [index]="i" [root]="true" (mouseEnterItemEvent)="onMouseEnterItem($event)"></li>
  }
</ul>
